import { AdminMenuItem } from './types'

export const AdminMenuItems: AdminMenuItem[] = [
    {
        id: 'generic',
        label: 'Generic',
        path: '/environment/edit',
        permission: 'kedo.env',
        icon: null,
    },
    {
        id: 'datastructures',
        label: 'Datastructures',
        path: '/datastructure',
        permission: 'kedo.datastructure',
        icon: null,
    },
    {
        id: 'erd',
        label: 'ERD',
        path: '/erd',
        permission: 'kedo.erd',
        icon: null,
    },
    {
        id: 'roles',
        label: 'Roles',
        path: '/roles',
        permission: 'kedo.role.index',
        icon: null,
    },
    {
        id: 'permissions',
        label: 'Permissions',
        path: '/permissions',
        permission: 'kedo.defdossierpermission',
        icon: null,
    },
    {
        id: 'logs',
        label: 'Logs',
        path: '/logs',
        permission: 'kedo.logs',
        icon: null,
    },
    {
        id: 'useractivity',
        label: 'User activity',
        path: '/useractivity',
        permission: 'kedo.useractivity',
        icon: null,
    },
    {
        id: 'files',
        label: 'Files',
        path: '/files',
        permission: 'kedo.file.index',
        icon: null,
    },
    {
        id: 'users',
        label: 'Users',
        path: '/user',
        permission: 'kedo.user.index',
        icon: null,
    },
    {
        id: 'languages',
        label: 'Languages',
        path: '/languages',
        permission: 'kedo.locale.index',
        icon: null,
    },
    {
        id: 'blocks',
        label: 'Blocks',
        path: '/blocks',
        permission: 'kedo.mypageblocks.index',
        icon: null,
    },
    {
        id: 'modules',
        label: 'Modules',
        path: '/modules',
        permission: 'kedo.module.index',
        icon: null,
    },
    {
        id: 'events',
        label: 'Events',
        path: '/events',
        permission: 'kedo.event.index',
        icon: null,
    },
    {
        id: 'kedocx',
        label: 'Kedocx',
        path: '/wordkedocx',
        permission: 'kedo.kedocx.index',
        icon: null,
    },
    {
        id: 'querybuilder',
        label: 'Querybuilder',
        path: '/querybuilder',
        permission: 'kedo.querybuilder',
        icon: null,
    },
    {
        id: 'webhooks',
        label: 'Webhooks',
        path: '/webhooks',
        permission: 'kedo.webhooks.index',
        icon: null,
    },
]
